







import Vue from 'vue'
export default Vue.extend({
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      required: true,
      validator: function(value: string) {
        return ['share', 'checkin', 'eatmap'].indexOf(value) !== -1
      }
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    getImage(): string {
      const img = require(`@/assets/images/ic-${this.icon}.svg`)
      return img
    }
  },
  methods: {
    handleClick: function(e: Event) {
      e.preventDefault()

      this.$emit('handleClick')
    }
  }
})
